import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
  required,
  maxLength,
  integer,
  minValue
} from "vuelidate/lib/validators";
import axios from 'axios';
import CONFIG from "@/assets/js/config.js";
import Loading from "vue-loading-overlay";

export default {
  name: "SalaryEdit",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      salaryData: [],
      teaArr: [],
      submitted: false,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      selectedMonth: null,
    };
  },

  validations: {
    salaryData: {
      total_salary: {
        required,
        integer,
        maxLength: maxLength(9),
        minValue: minValue(0)
      }
    },
  },

  methods: {
    getTeacher() {
      axios.get('teacher/getallTeacher',{ params: { campus_id: this.$store.state.user.campus_id } } )
      .then(res => {
        if (res.data[0].length != 0) {
          this.teaArr = res.data[0];
        }
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getDetail() {
      axios.get(`salary/detail/${this.$route.params.id}`, { 
            params: {
                campus_id: this.$store.state.user.campus_id,
                is_edit: true
          } 
        })
        .then((res) => {
          if (res.data) {
            this.salaryData = res.data.data;
            const adjustedMonth = new Date(this.salaryData.month);
            this.salaryData.month = adjustedMonth.toISOString().slice(0, 7);
            this.selectedMonth = this.salaryData.month;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    update() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;
      this.salaryData.login_id = this.$store.state.user.id;
      this.salaryData.campus_id = this.$store.state.user.campus_id;
      axios.post(`salary/update/${this.$route.params.id}`, this.salaryData)
        .then(res => {
          if (res.data) {
            this.$notification.success("Salary Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "salaryList"
            });
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.disabled = false;
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getTeacher();
    this.getDetail();
  },
};
